import { DebugMessage } from "@/components/DebugLog/types";
import emitter from "tiny-emitter/instance";

/**
 * Emittar meddelandet till DebugLog.vue om hash innehåller "debug"
 */
export const logDebug = ({ message }: { message: DebugMessage }) => {
    if (location?.hash?.includes?.("debug")) {
        emitter.emit("debug-log", { message });
    }
};

/**
 * Returnerar om debug är satt eller inte. Kollar även customhash om det skickats med. Avskiljare mellan
 * custom hashes är &.
 * Den kollar på om den ine är i debug istället för om den är det för att göra koden mer läsbar där funktionen används
 * (koden som ska köras när det INTE är i debug mode hamnar högst upp)
 */
export const isProdMode = ({ customHash }: { customHash?: string }) => {
    const isDebug = location?.hash?.includes?.("debug");

    if (customHash) {
        return !isDebug || !location?.hash?.includes?.(`&${customHash}`);
    }

    return !isDebug;
};
